import { breakpoints, Icon } from '@components/gassan-ui'
import { cn } from '@lib/cn'
import { useBreakpoint } from '@lib/hooks/useBreakpoint'
import React, { FC, HTMLAttributes } from 'react'

type NavButtonProps = HTMLAttributes<HTMLButtonElement> & {
  direction: 'left' | 'right'
  persistent?: boolean
}

export const NavButton: FC<NavButtonProps> = ({ direction, className, persistent, ...rest }) => {
  const isDesktop = useBreakpoint(breakpoints.large)

  return (
    <button
      className={cn(
        'absolute top-1/2 z-10 h-[84px] w-[84px] -translate-y-1/2 rounded-full text-white outline-none',
        'lg:h-[42px] lg:w-[42px]',
        persistent ? 'block' : 'hidden lg:block',
        direction === 'left' ? 'left-0' : 'right-0',
        className,
      )}
      {...rest}
    >
      {direction === 'left' ? (
        <Icon icon="chevron-left" size={isDesktop ? 42 : 84} />
      ) : (
        <Icon icon="chevron-right" size={isDesktop ? 42 : 84} />
      )}
    </button>
  )
}
